// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__262TN","info":"UpdateTermsInfo_info__3Emn_"};